import { useLiveRoom } from "@circle-react/components/LiveStreams/hooks";
import { useWhiteLabel } from "@circle-react/hooks/useWhiteLabel";

import { classNames } from "@/react/helpers/twMergeWithCN";

import { useSidebarBorderStyles } from "../../SidebarV2/hooks";
import { useShouldDisplayGoLiveFooter } from "../../SidebarV2/SidebarFooter/useShouldDisplayGoLiveFooter";
import { COMPASS_DEFAULT_INTERACTIVE_HOVER_CLASSES } from "../constants";
import { GoLive } from "./GoLive";
import { LiveIndicator } from "./LiveIndicator";
import { PoweredByCircle } from "./PoweredByCircle";

export interface FooterSectionProps {
  isPreviewMode?: boolean;
}

export const FooterSection = ({
  isPreviewMode = false,
}: FooterSectionProps) => {
  const { room } = useLiveRoom();
  const hasGoLiveButton = useShouldDisplayGoLiveFooter();
  const { shouldShowBranding } = useWhiteLabel();

  const styles = useSidebarBorderStyles();

  if (!room && !hasGoLiveButton && !shouldShowBranding) {
    return null;
  }

  return (
    <>
      <LiveIndicator />
      {(hasGoLiveButton || shouldShowBranding) && (
        <div
          style={styles}
          className={classNames(
            "border-c-sidebar bg-c-sidebar flex shrink-0 flex-col gap-2 border-t px-5 py-4",
            COMPASS_DEFAULT_INTERACTIVE_HOVER_CLASSES,
          )}
        >
          {hasGoLiveButton && <GoLive isPreviewMode={isPreviewMode} />}
          {shouldShowBranding && <PoweredByCircle />}
        </div>
      )}
    </>
  );
};
